import { getMappedEvents } from '../utils/getMappedEvents';

const EVENTS = ['srtDownloadUpgradeClick'] as const;

export const srtDownloadEvents = getMappedEvents([...EVENTS], {
  shouldSendRaskTTSData: true,
  shouldSendSubscriptionData: true,
});
